export default __webpack_public_path__ + "static/media/hareketli video-01.0e091944.png";